import { createContext, useState, useContext, useMemo, ReactNode } from 'react';

type FeedType = 'snaps' | 'drools';

interface FeedContextType {
  activeFeed: FeedType;
  setActiveFeed: (feed: FeedType) => void;
  showFeedToggle: boolean;
  setShowFeedToggle: (show: boolean) => void;
  hideChrome: boolean;
  setHideChrome: (hide: boolean) => void;
}

const FeedContext = createContext<FeedContextType | undefined>(undefined);

export const FeedProvider = ({ children }: { children: ReactNode }) => {
  const [activeFeed, setActiveFeed] = useState<FeedType>('drools');
  const [showFeedToggle, setShowFeedToggle] = useState(false);
  const [hideChrome, setHideChrome] = useState(false);

  const value = useMemo(() => ({
    activeFeed, setActiveFeed, showFeedToggle, setShowFeedToggle, hideChrome, setHideChrome,
  }), [activeFeed, showFeedToggle, hideChrome]);

  return (
    <FeedContext.Provider value={value}>
      {children}
    </FeedContext.Provider>
  );
};

export const useFeedContext = () => {
  const context = useContext(FeedContext);
  if (!context) {
    throw new Error('useFeedContext must be used within a FeedProvider');
  }
  return context;
};
